<div class="create-order-dialog">
  <header class="dialog-header">
    <div class="dialog-header__icon" aria-hidden="true">
      <mat-icon>receipt_long</mat-icon>
    </div>
    <div class="dialog-header__text">
      <h2 mat-dialog-title>Crear Orden de Servicio</h2>
      <p *ngIf="contextLabel" class="dialog-header__context">{{ contextLabel }}</p>
    </div>
  </header>

  <!-- FORMULARIO -->
  <form *ngIf="state === 'form'" [formGroup]="form" class="dialog-form">
    <mat-dialog-content class="dialog-body">
      <div class="summary-card">
        <div class="summary-card__count">{{ serviceIds.length }}</div>
        <div class="summary-card__info">
          <strong>
            servicio{{ serviceIds.length === 1 ? '' : 's' }} seleccionado{{
              serviceIds.length === 1 ? '' : 's'
            }}
          </strong>
          <span *ngIf="ticketSelectionCount > 0">
            {{ ticketSelectionCount }} ticket(s) puntual(es). Se crea 1 OS por
            ticket indicado.
          </span>
          <span *ngIf="ticketSelectionCount === 0">
            Se agrupan por proveedor y moneda. En ticketería, una OS por cada
            ticket libre.
          </span>
        </div>
      </div>

      <div *ngIf="errorMessage" class="alert alert--error">
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong *ngIf="errorTitle">{{ errorTitle }}</strong>
          <span>{{ errorMessage }}</span>
        </div>
      </div>

      <section class="fields-section">
        <label class="co-switch-row" [class.is-on]="form.value.asOfficial" for="co-asOfficial">
          <input
            id="co-asOfficial"
            class="co-switch-row__input"
            type="checkbox"
            formControlName="asOfficial"
          />
          <span class="co-switch" aria-hidden="true">
            <span class="co-switch__knob"></span>
          </span>
          <span class="co-switch-row__copy">
            <strong>Crear como confirmada</strong>
            <span>Nace oficial, congela el costo y genera el PDF.</span>
          </span>
        </label>

        <div class="co-dates" [class.co-dates--single]="form.value.asOfficial">
          <div class="co-field-group">
            <label class="co-field-group__label" for="co-scheduledPaymentDate">
              Pago programado
            </label>
            <div class="co-date-field">
              <input
                id="co-scheduledPaymentDate"
                class="co-date-field__input"
                [matDatepicker]="dp"
                formControlName="scheduledPaymentDate"
                placeholder="dd/mm/aaaa"
                autocomplete="off"
                readonly
                (click)="dp.open()"
              />
              <button
                type="button"
                class="co-date-field__icon"
                (click)="dp.open()"
                aria-label="Abrir calendario de pago programado"
              >
                <mat-icon>event</mat-icon>
              </button>
              <mat-datepicker #dp panelClass="os-datepicker-panel"></mat-datepicker>
            </div>
            <p class="co-field-group__hint">Vacío: el sistema la calcula.</p>
          </div>

          <div class="co-field-group" *ngIf="!form.value.asOfficial">
            <label class="co-field-group__label" for="co-freezeDeadlineAt">
              Plazo para confirmar la OS
            </label>
            <div class="co-date-field">
              <input
                id="co-freezeDeadlineAt"
                class="co-date-field__input"
                [matDatepicker]="cortePicker"
                formControlName="freezeDeadlineAt"
                placeholder="dd/mm/aaaa"
                autocomplete="off"
                readonly
                (click)="cortePicker.open()"
              />
              <button
                type="button"
                class="co-date-field__icon"
                (click)="cortePicker.open()"
                aria-label="Abrir calendario del plazo para confirmar"
              >
                <mat-icon>event</mat-icon>
              </button>
              <mat-datepicker
                #cortePicker
                panelClass="os-datepicker-panel"
              ></mat-datepicker>
            </div>
            <p class="co-field-group__hint">
              Ya viene calculado: 45 días antes de la fecha del servicio.
              Tienes hasta ese día para confirmarla; mientras tanto es un
              borrador y puedes cambiar su precio y pasajeros.
            </p>
            <p
              class="co-field-group__hint co-field-group__hint--error"
              *ngIf="
                !form.value.asOfficial && form.get('freezeDeadlineAt')?.invalid
              "
            >
              Elige una fecha: el plazo es obligatorio.
            </p>
          </div>
        </div>

        <div class="co-field-group">
          <label class="co-field-group__label" for="co-reservationNumber">
            N° de reserva
          </label>
          <input
            id="co-reservationNumber"
            class="co-text-field"
            type="text"
            formControlName="reservationNumber"
            placeholder="Ej. 32411"
            autocomplete="off"
          />
        </div>

        <div class="co-field-group">
          <label class="co-field-group__label" for="co-commissionEnabled">
            Comisión
          </label>

          <label
            class="co-switch-row"
            [class.is-on]="form.value.commissionEnabled"
            for="co-commissionEnabled"
          >
            <input
              id="co-commissionEnabled"
              class="co-switch-row__input"
              type="checkbox"
              formControlName="commissionEnabled"
            />
            <span class="co-switch" aria-hidden="true">
              <span class="co-switch__knob"></span>
            </span>
            <span class="co-switch-row__copy">
              <strong>Incluir comisión</strong>
              <span>Se suma al monto y sale en el PDF.</span>
            </span>
          </label>

          <div *ngIf="form.value.commissionEnabled" class="co-commission-panel">
            <div class="co-segment" role="radiogroup" aria-label="Tipo de comisión">
              <label [class.is-on]="form.value.commissionType === 'PERCENTAGE'">
                <input type="radio" formControlName="commissionType" value="PERCENTAGE" />
                Porcentaje
              </label>
              <label [class.is-on]="form.value.commissionType === 'FIXED'">
                <input type="radio" formControlName="commissionType" value="FIXED" />
                Monto fijo
              </label>
            </div>

            <label class="co-commission-value">
              <span class="co-commission-value__label">Valor</span>
              <span
                class="co-commission-value__box"
                [class.is-invalid]="showCommissionError"
              >
                <input
                  type="number"
                  min="0.01"
                  step="0.01"
                  formControlName="commissionValue"
                  (blur)="markCommissionTouched()"
                  [placeholder]="form.value.commissionType === 'FIXED' ? '0.00' : ''"
                />
                <span class="co-commission-value__suffix">
                  {{ form.value.commissionType === 'PERCENTAGE' ? '%' : 'fijo' }}
                </span>
              </span>
            </label>

            <p class="co-field-group__hint co-field-group__hint--error" *ngIf="showCommissionError">
              {{ commissionError }}
            </p>
            <p class="co-field-group__hint" *ngIf="!showCommissionError">
              En varias OS, este valor se aplica a cada una.
            </p>
          </div>
        </div>

        <div class="co-field-group">
          <label class="co-field-group__label" for="co-orderObservation">
            Observación
          </label>
          <textarea
            id="co-orderObservation"
            class="co-textarea-field"
            rows="2"
            formControlName="orderObservation"
            placeholder="Notas para la OS"
          ></textarea>
        </div>
      </section>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-stroked-button type="button" class="co-btn co-btn--ghost" (click)="cancelar()" [disabled]="isBusy">
        Cancelar
      </button>
      <button
        mat-flat-button
        type="button"
        class="co-btn co-btn--primary"
        (click)="crearOS()"
        [disabled]="!canSubmit"
      >
        Crear OS
      </button>
    </mat-dialog-actions>
  </form>

  <!-- CARGANDO (job PENDING / PROCESSING) -->
  <mat-dialog-content *ngIf="state === 'loading'" class="dialog-body dialog-body--center">
    <mat-spinner [diameter]="40"></mat-spinner>
    <p class="state-title">Creando órdenes de servicio…</p>
    <p class="state-subtitle">
      Esto puede tardar unos segundos mientras se numeran y confirman los
      servicios.
    </p>
  </mat-dialog-content>

  <!-- ERROR DE JOB -->
  <ng-container *ngIf="state === 'error'">
    <mat-dialog-content class="dialog-body">
      <div class="alert alert--error">
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong *ngIf="errorTitle">{{ errorTitle }}</strong>
          <span>{{ errorMessage }}</span>
        </div>
      </div>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button
        mat-stroked-button
        type="button"
        class="co-btn co-btn--ghost"
        (click)="cerrarYActualizar()"
      >
        Cerrar y actualizar
      </button>
      <button
        mat-flat-button
        type="button"
        class="co-btn co-btn--primary"
        (click)="crearOS()"
      >
        Reintentar
      </button>
    </mat-dialog-actions>
  </ng-container>

  <!-- RESULTADO -->
  <ng-container *ngIf="state === 'result'">
    <mat-dialog-content class="dialog-body">
      <div *ngIf="hasCreated && !hasWarnings && !hasRejections" class="result-banner">
        <mat-icon>check_circle</mat-icon>
        <div>
          <strong>Órdenes creadas correctamente</strong>
          <span>{{ createdOrders.length }} OS generada(s)</span>
        </div>
      </div>

      <div
        *ngIf="hasCreated && (hasWarnings || hasRejections)"
        class="result-banner result-banner--warn"
      >
        <mat-icon>warning_amber</mat-icon>
        <div>
          <strong>OS creada con observaciones</strong>
          <span>
            {{ createdOrders.length }} OS generada(s). Revisa las advertencias
            antes de continuar.
          </span>
        </div>
      </div>

      <div
        *ngIf="!hasCreated && (hasWarnings || hasRejections)"
        class="result-banner result-banner--error"
      >
        <mat-icon>error_outline</mat-icon>
        <div>
          <strong>No se creó ninguna OS</strong>
          <span>Revisa el detalle de lo no procesado.</span>
        </div>
      </div>

      <section *ngIf="payRows.length > 0" class="result-block">
        <h3 class="result-block__title">Desglose a pagar</h3>
        <div *ngFor="let order of payRows" class="os-pay-breakdown">
          <p class="os-pay-breakdown__os">OS {{ order.displayCode || order.orderNumber }}</p>
          <ng-container *ngIf="order.commissionAmount != null">
            <div class="os-pay-breakdown__row">
              <span>Monto</span>
              <span>{{ order.baseAmount | number: '1.2-2' }}</span>
            </div>
            <div class="os-pay-breakdown__row">
              <span>{{ commissionLabel(order) }}</span>
              <span>{{ order.commissionAmount | number: '1.2-2' }}</span>
            </div>
          </ng-container>
          <div class="os-pay-breakdown__row os-pay-breakdown__row--total">
            <span>Total</span>
            <span>{{ order.total | number: '1.2-2' }}</span>
          </div>
        </div>
      </section>

      <section *ngIf="warningCards.length > 0" class="result-block">
        <h3 class="result-block__title result-block__title--warn">
          Advertencias ({{ warningCards.length }})
        </h3>
        <div *ngFor="let card of warningCards" class="issue-card issue-card--warn">
          <div class="issue-card__icon" aria-hidden="true">
            <mat-icon>info</mat-icon>
          </div>
          <div class="issue-card__body">
            <strong class="issue-card__title">{{ card.title }}</strong>
            <p class="issue-card__text">{{ card.body }}</p>
            <p class="issue-card__meta" *ngIf="card.serviceIds.length > 1">
              Afecta a {{ card.serviceIds.length }} servicios
            </p>
          </div>
        </div>
      </section>

      <section *ngIf="rejectionCards.length > 0" class="result-block">
        <h3 class="result-block__title result-block__title--error">
          No procesados ({{ rejectedServices.length }})
        </h3>
        <div
          *ngFor="let card of rejectionCards"
          class="issue-card issue-card--error"
        >
          <div class="issue-card__icon" aria-hidden="true">
            <mat-icon>block</mat-icon>
          </div>
          <div class="issue-card__body">
            <strong class="issue-card__title">{{ card.title }}</strong>
            <p class="issue-card__text">{{ card.body }}</p>
            <p class="issue-card__meta" *ngIf="card.ticketId">
              Ticket: {{ card.ticketId }}
            </p>
            <p class="issue-card__meta" *ngIf="card.serviceId && !card.ticketId">
              Servicio: {{ card.serviceId }}
            </p>
            <p class="issue-card__meta" *ngIf="card.serviceId && card.ticketId">
              Servicio: {{ card.serviceId }}
            </p>
          </div>
        </div>
      </section>

      <section *ngIf="createdOrders.length > 0" class="result-block">
        <h3 class="result-block__title">Órdenes creadas</h3>
        <article
          *ngFor="let os of createdOrders"
          class="os-card"
          [class.os-card--preliminar]="os.orderStatus === 'PRELIMINAR'"
        >
          <div class="os-card__head">
            <div>
              <span class="os-card__label">Número OS</span>
              <strong class="os-card__number">N° {{ os.displayCode || os.orderNumber }}</strong>
            </div>
            <span
              class="os-status"
              [attr.data-os-status]="(os.orderStatus || '').toUpperCase()"
            >
              {{ os.orderStatus }}
            </span>
          </div>

          <ul class="os-meta">
            <li>{{ os.serviceIds?.length || 0 }} servicio(s)</li>
            <li *ngIf="os.ticketIds?.length">{{ os.ticketIds?.length }} ticket(s)</li>
            <li *ngIf="os.currency">{{ os.currency }}</li>
            <li *ngIf="os.orderStatus === 'PRELIMINAR' && freezeLabel(os) as corte">
              Confirmar antes del {{ corte }}
            </li>
            <li *ngIf="getReservationNumber(os) as reserva">Reserva: {{ reserva }}</li>
          </ul>

          <p
            class="os-pdf-note"
            *ngIf="os.pdfStatus === 'PENDING' || os.pdfStatus === 'PROCESSING'"
          >
            El PDF de la OSS quedó disponible en el sistema.
          </p>
          <button
            *ngIf="os.orderStatus === 'PRELIMINAR'"
            type="button"
            class="os-confirm"
            [disabled]="confirmingOrderId === os.orderId"
            (click)="confirmar(os)"
          >
            {{ confirmingOrderId === os.orderId ? 'Confirmando...' : 'Confirmar OS' }}
          </button>
        </article>
      </section>

      <p
        *ngIf="
          createdOrders.length === 0 &&
          rejectedServices.length === 0 &&
          warnings.length === 0
        "
        class="state-subtitle state-subtitle--center"
      >
        No se recibió información de resultado.
      </p>
    </mat-dialog-content>

    <mat-dialog-actions class="dialog-actions">
      <button mat-flat-button type="button" class="co-btn co-btn--primary" (click)="cerrar()">
        {{ needsDataRefresh ? 'Entendido y actualizar' : 'Entendido' }}
      </button>
    </mat-dialog-actions>
  </ng-container>
</div>
